export default "__VITE_ASSET__U1v5bYj7__"